import { Inject, Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { CORE_CONFIGURATION } from '../../core/configuration';
import { ApiModule } from './api.module';
import { BaseApiService } from './base-api.service';
import { SessionState, SessionStateModel } from '../session';
import { Store } from '@ngxs/store';
import { buildAwsApi, setObjectParams } from '../util.class';
import { NewsFilteredList } from 'src/app/news/shared/models/news-filtered-data.model';

@Injectable({
  providedIn: ApiModule,
  deps: [BaseApiService],
})
export class NewsApiService {
  keyMapAWS: any;

  constructor(
    private http: BaseApiService,
    private _store: Store,
    @Inject(CORE_CONFIGURATION) private config) {
    const { keyMapAWS }: SessionStateModel = this._store.selectSnapshot(SessionState);
    this.keyMapAWS = keyMapAWS;
  }


  allNewsList(){
    const apiAWS = buildAwsApi(this.keyMapAWS,'news_list_no_msisdn',{'contenttype':'HTML','newsContent':true,'allContent':true});

    return this.http.get({
      apiBasePath: this.config.apiBasePath,
      path:  apiAWS ??  '/news/v1/listfeed/3421210045/2024-09-24/TXT',
      awsApi: apiAWS !== null
    });
  }


  /**
    * news api get news list
    * @param msisdn current msisdn
    * @param elementLimit the max number of elements we want to get
    * @param elementOffset the index of the first element we'll get
    */
  newsList(msisdn: string, limit: number, offset: number): Observable<any> {
    // if keyMapAWS is present, we should use it!
    const apiAWS = buildAwsApi(this.keyMapAWS,'news_feed', {'msisdn': msisdn} );
    const params = setObjectParams({limit, offset});

    return this.http.get({
      apiBasePath: this.config.apiBasePath,
      path: apiAWS ?? `/v2/news/v1/feed/${msisdn}`,
      params,
      awsApi: apiAWS !== null
    });
  }

  /**
    * news api get news detail
    * @param msisdn current msisdn
    * @param newsId the id of the news we want to get the details of
    */
  newsDetail(msisdn: string, newsId: string): Observable<any> {

    // if keyMapAWS is present, we should use it!
    const apiAWS = buildAwsApi(this.keyMapAWS,'news_feed_details',
      { 'msisdn': msisdn,
        'idNews': newsId }
    );

    return this.http.get({
      apiBasePath: this.config.apiBasePath,
      path: apiAWS ?? `/v2/news/v1/feed/${msisdn}/${newsId}/`,
      awsApi: apiAWS !== null
    });
  }


  filteredNews(username:string): Observable<NewsFilteredList> {
    const apiAWS = buildAwsApi(this.keyMapAWS,'news_retrieve_news',{username:username});
    return this.http.get({
      apiBasePath: this.config.apiBasePath,
      path: apiAWS ?? '/news/test/feed/',
      awsApi: apiAWS !== null
    });
  }

}
